import { Volume2, Trophy, Music } from "lucide-react";

export function AudioGate({ audioBusy, audioPlayed, audioError, onListen, onContinue, onSkip }) {
  return (
    <div className="min-h-screen bg-[#FAF7EE] flex items-center justify-center px-5" data-testid="audio-check">
      <div className="w-full max-w-md rounded-2xl bg-white border border-[#E5DEC9] p-8 text-center">
        <Volume2 className="w-10 h-10 text-[#C69B3D] mx-auto" aria-hidden />
        <h1 className="font-display text-2xl font-bold text-[#0B192C] mt-4">Can you hear this note?</h1>
        <p className="text-sm text-[#566270] mt-2">This activity uses sound. Check your volume is up, then listen.</p>
        <button onClick={onListen} disabled={audioBusy} data-testid="audio-check-listen"
          className="mt-6 w-full inline-flex items-center justify-center gap-2 px-5 py-4 rounded-2xl bg-[#0B192C] text-[#FAF7EE] font-bold min-h-[52px] disabled:opacity-50">
          <Volume2 className="w-5 h-5 text-[#C69B3D]" aria-hidden /> {audioPlayed ? "↻ Play again" : "▶ Listen"}
        </button>
        {audioError && <p role="alert" className="mt-3 text-sm text-[#A62B2B]" data-testid="audio-error">{audioError}</p>}
        {audioPlayed && !audioError && (
          <button onClick={onContinue} data-testid="audio-check-yes"
            className="mt-3 w-full px-5 py-4 rounded-2xl bg-[#C69B3D] text-[#0B192C] font-bold hover:bg-[#D8AB49] min-h-[52px]">
            Yes, I can hear it — let's go
          </button>
        )}
        <button onClick={onSkip} className="mt-3 text-xs text-[#566270] underline min-h-[44px]" data-testid="audio-check-skip">
          My sound isn't working — continue anyway
        </button>
      </div>
    </div>
  );
}

export function SessionSummary({ summary, isTest, onHome }) {
  return (
    <div className="min-h-screen bg-[#0B192C] text-[#FAF7EE] flex items-center justify-center px-5" data-testid="session-summary">
      <div className="w-full max-w-md text-center">
        <Trophy className="w-14 h-14 text-[#C69B3D] mx-auto" aria-hidden />
        <h1 className="font-display text-3xl font-bold mt-4">
          {summary.perfect ? "A perfect round!" : isTest ? "Test complete" : "Well sung!"}
        </h1>
        <p className="text-[#FAF7EE]/70 mt-2" data-testid="summary-score">You scored {summary.score} out of {summary.total}.</p>
        {summary.bonus_notes > 0 && (
          <p className="mt-4 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#C69B3D] text-[#0B192C] font-bold" data-testid="summary-bonus">
            <Music className="w-4 h-4" aria-hidden /> +{summary.bonus_notes} Notes
          </p>
        )}
        <p className="text-sm text-[#FAF7EE]/60 mt-3" data-testid="summary-notes-total">
          {summary.notes_total.toLocaleString()} Notes in total · {summary.streak}-day streak
        </p>
        <button onClick={onHome} data-testid="back-home-btn"
          className="mt-8 w-full px-6 py-4 rounded-2xl bg-[#FAF7EE] text-[#0B192C] font-bold hover:bg-white transition-colors min-h-[52px]">
          Back to ChoirQuest
        </button>
      </div>
    </div>
  );
}

export function FeedbackPanel({ feedback }) {
  return (
    <div className={`mt-5 rounded-2xl border-2 p-5 ${feedback.duplicate ? "border-[#E5DEC9] bg-[#F3EFE0]" : feedback.correct ? "border-[#2D6A4F] bg-[#EBF6F0]" : "border-[#B8860B] bg-[#F6EED8]"}`}
      data-testid="feedback-panel">
      <p className="font-bold text-[#0B192C]" data-testid="feedback-verdict">
        {feedback.duplicate ? "Already recorded" : feedback.correct ? `Correct! +${feedback.notes_awarded} Notes` : "Nearly!"}
      </p>
      {feedback.explanation && (
        <p className="text-sm text-[#1C242B] mt-1.5 leading-relaxed" data-testid="feedback-explanation">
          {feedback.correct ? feedback.explanation : `Remember: ${feedback.explanation}`}
        </p>
      )}
    </div>
  );
}
